import React from 'react';
import Animated from './logo3.svg';

function App() {
  return (
    <object type="image/svg+xml" data={Animated} className="robot"></object>
  );
}
export default App;